import { render, staticRenderFns } from "./edit-service.vue?vue&type=template&id=dd9d8c5c&scoped=true"
import script from "./edit-service.vue?vue&type=script&lang=js"
export * from "./edit-service.vue?vue&type=script&lang=js"
import style0 from "./edit-service.vue?vue&type=style&index=0&id=dd9d8c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d8c5c",
  null
  
)

export default component.exports